import React from 'react';
import { TextField } from '@material-ui/core';
import { FormControl } from '@material-ui/core';
import { InputLabel } from '@material-ui/core';

const QuestionaireMultiTextBox = ({id, text, index, required, answer, onAnswer }) => {
    const jsonUnescape = (str) =>{
        return  str.replace(/&#39;/g, "'").replace(/&#34;/, "\"").replace(/\\\\/g, "\\");
    }
    return ( 
        <React.Fragment>
            <div className='customer_questionnaire_field'>
                <InputLabel>{`${index} ${text}`}</InputLabel>

                <FormControl fullWidth>
                
                    <TextField multiline placeholder="" id={id} name={id} value={answer.answer} rows={4} required={required} autoFocus={id===1? true: false } autoComplete={id + Date.now().toString()} onChange={(e) => {
                        console.log("Updated text", e.target.value);
                        onAnswer(id, e.target.value);
                    }} />
                </FormControl>  
               
            </div>
        </React.Fragment>
        

     );
}
export default QuestionaireMultiTextBox;